import { render } from "./FormDatetime.vue?vue&type=template&id=33ce10ce"
import script from "./FormDatetime.vue?vue&type=script&lang=js"
export * from "./FormDatetime.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Form/FormDatetime.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33ce10ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33ce10ce', __exports__)) {
    console.log('reload')
    api.reload('33ce10ce', __exports__)
  }
  
  module.hot.accept("./FormDatetime.vue?vue&type=template&id=33ce10ce", () => {
    console.log('re-render')
    api.rerender('33ce10ce', render)
  })

}


export default __exports__